import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Jumbotron.css';
import heroBgMobile from '../../img/header_background_7-512.webp';
import heroBgTablet from '../../img/header_background_7-768.webp';
import heroBgDesktop from '../../img/header_background_7.webp';

function Jumbotron (props) {
  const headline = props.headline;
  const subtitle = props.subtitle;

  return (
    <section className="jumbotron-fluid bg-img">
      <Helmet>
        <link rel="preload" as="image" href={heroBgMobile} media="(max-width: 767px)" fetchpriority="high" />
        <link rel="preload" as="image" href={heroBgTablet} media="(min-width: 768px) and (max-width: 991px)" fetchpriority="high" />
        <link rel="preload" as="image" href={heroBgDesktop} media="(min-width: 992px)" fetchpriority="high" />
      </Helmet>
      <div className="container text-center jumbo">
        <h1 className="bigger">{headline}</h1>
        <p className="big">{subtitle}</p>
        <div className="container">
          <div className="row justify-content-center">
            {props.children}
          </div>
        </div>
      </div>
    </section>
  );
}
export default Jumbotron;